export const MAIN_PATH = '/user-invitations';

export const ROUTES = {
  MAIN_PATH,
  USER_INVITATION_CREATE: `${MAIN_PATH}/create`,
  USER_INVITATION_UPDATE: `${MAIN_PATH}/:id/edit`,
  USER_INVITATION_ACCEPT: `${MAIN_PATH}/accept`,
};
